
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Loading, LavorazioniList, LavorazioniCards, LoadingTemplateType } from "@/components";
import { LavorazioneSlim, StatoLavorazione, Utente, FinderLavorazioni } from '@/models';
import { store, StoreActions, StoreMutations, FiltriLavorazioni } from '@/store';

@Component({
    components: {
        Loading,
        LavorazioniCards,
        LavorazioniList
    },
})
export default class Lavorazioni extends Vue {

    get loading() { return store.state.loading; }

    get user() { return store.state.currentUsr; }

    get userIsAdmin() { return this.user.roles.find((x: string) => x.toLowerCase() == 'admin') != undefined; }

    get stati() { return Object.values(StatoLavorazione); }

    get pageSize(): number { return store.state.ui.dimensionePaginaListe; }

    get page(): number { return store.state.uiLavorazioni.pagina; }
    set page(value: number) { this.caricaPaginaLavorazioni(value); }

    get pageCount(): number { return store.state.uiLavorazioni.totPagine; }
    get numTotLavorazioni(): number { return store.state.uiLavorazioni.totLavorazioni; }

    get fornitori (): Utente[]  { return store.state.fornitori; }

    get fornitore (): Utente | undefined  { return store.state.fornitore; }

    set fornitore (fornitore: Utente | undefined) {
        store.commit(StoreMutations.SetFornitore, fornitore);
        if(fornitore) {
            this.idFornitore = fornitore.id;
            this.caricaPaginaLavorazioni(1);
        } else {
            this.idFornitore = '';
            store.commit(StoreMutations.SetLavorazioni, []);
        }
        //store.dispatch(StoreActions.GetDatiLookupFornitore, this.idFornitore);
    }

    private idFornitore: string = '';

    created(): void {
        this.updateTitolo(store.state.uiLavorazioni.filtroStatoOrdini);
        if(this.userIsAdmin) {
            this.fornitore = undefined;
            store.dispatch(StoreActions.GetFornitori);
        }
        else {
            this.idFornitore = this.user.idFornitore;
            this.caricaPaginaLavorazioni(1);
        }
    }

    private caricaPaginaLavorazioni(pagina: number): void {

        if(this.idFornitore) {
            let parametri: FinderLavorazioni = new FinderLavorazioni(this.idFornitore, pagina);
            parametri.ApplicaFiltriLavorazioni(store.state.uiLavorazioni.filtri, this.getStatoLavorazioneValue(this.filtroStatoOrdini));
            parametri.filterDatiAggiuntiviLavorazioniForList = true;
            store.dispatch(StoreActions.GetLavorazioniFornitore, parametri);
        }
    }

    getStatoLavorazioneIndex(stato: StatoLavorazione): number{
        switch(stato) {
            case StatoLavorazione.IN_ATTESA_DI_ACCETTAZIONE_DI_FORNITORE: return 0;
            case StatoLavorazione.IN_ATTESA_DI_ACCETTAZIONE_DI_BC: return 1;
            case StatoLavorazione.ACCETTATO_IN_ATTESA_DI_CONSEGNA_A_FORNITORE: return 2;
            case StatoLavorazione.CONSEGNATO_A_FORNITORE: return 3;
            case StatoLavorazione.CONSEGNA_A_FORNITORE_PROCESSATA: return 4;
            case StatoLavorazione.IN_CORSO_DI_LAVORAZIONE: return 5;
            case StatoLavorazione.COMPLETATO_IN_ATTESA_DI_RIENTRO: return 6;
            case StatoLavorazione.RIENTRATO: return 7;
            case StatoLavorazione.RIENTRO_PROCESSATO: return 8;
        }
        return 0;
    }
    getStatoLavorazioneValue(index: number): StatoLavorazione{
        switch(index) {
            case 0: return StatoLavorazione.IN_ATTESA_DI_ACCETTAZIONE_DI_FORNITORE;
            case 1: return StatoLavorazione.IN_ATTESA_DI_ACCETTAZIONE_DI_BC;
            case 2: return StatoLavorazione.ACCETTATO_IN_ATTESA_DI_CONSEGNA_A_FORNITORE;
            case 3: return StatoLavorazione.CONSEGNATO_A_FORNITORE;
            case 4: return StatoLavorazione.CONSEGNA_A_FORNITORE_PROCESSATA;
            case 5: return StatoLavorazione.IN_CORSO_DI_LAVORAZIONE;
            case 6: return StatoLavorazione.COMPLETATO_IN_ATTESA_DI_RIENTRO;
            case 7: return StatoLavorazione.RIENTRATO;
            case 8: return StatoLavorazione.RIENTRO_PROCESSATO;
        }
        return StatoLavorazione.IN_ATTESA_DI_ACCETTAZIONE_DI_FORNITORE;
    }

    @Watch("$store.state.uiLavorazioni.filtri")
    onCambioFiltri(filtriNew: FiltriLavorazioni) {
        this.caricaPaginaLavorazioni(store.state.uiLavorazioni.pagina);
    }

    get loadTemplateCorrente() : LoadingTemplateType {
        return store.state.uiLavorazioni.listView ? LoadingTemplateType.TwoLineAvatarList : LoadingTemplateType.Card;
    }

    get filtroStatoOrdini(): number {
        if(store.state.uiLavorazioni.filtroStatoOrdini && store.state.uiLavorazioni.filtroStatoOrdini.length > 0) {
            return this.getStatoLavorazioneIndex(store.state.uiLavorazioni.filtroStatoOrdini[0]);
        }
        return 0;
    }
    set filtroStatoOrdini(value: number) {
        store.commit(StoreMutations.SetFiltroStatoOrdini, [this.getStatoLavorazioneValue(value)]);
    }

    get vistaLista(): boolean {
        return store.state.uiLavorazioni.listView;
    }

    @Watch("$store.state.uiLavorazioni.filtroStatoOrdini")
    updateTitolo(filtro: StatoLavorazione[]) {
        let titolo = "In lavorazione";

        if(store.state.uiLavorazioni.filtroStatoOrdini.find(s => s === StatoLavorazione.IN_ATTESA_DI_ACCETTAZIONE_DI_FORNITORE))
            titolo = "In attesa di accettazione da parte del Fornitore";
        else if(store.state.uiLavorazioni.filtroStatoOrdini.find(s => s === StatoLavorazione.IN_ATTESA_DI_ACCETTAZIONE_DI_BC))
            titolo = "In attesa di accettazione da parte della B.C.";

        store.commit(StoreMutations.SetSottotitoloPagina, titolo);
        this.caricaPaginaLavorazioni(store.state.uiLavorazioni.pagina);
    }

    private mounted() {
        if(this.fornitore) {
            this.startWatchRemoteChanges(this.fornitore.id);
        }
    }

    private destroyed() {
        if(this.fornitore) {
            this.stopWatchRemoteChanges(this.fornitore.id);
        }
    }

    @Watch("fornitore")
    onFornitoreChanged(newValue: Utente, oldValue: Utente) {
        console.log(`Fornitore cambiato.`);
        if(newValue != oldValue) {
            if(oldValue && oldValue.id) {
                this.stopWatchRemoteChanges(oldValue.id);
            }
            if(newValue && newValue.id) {
                this.startWatchRemoteChanges(newValue.id);
            }
        }
    }

    private startWatchRemoteChanges(idFornitore: string) {
        store.dispatch(StoreActions.WatchLavorazioniFornitore, idFornitore);
    }

    private stopWatchRemoteChanges(idFornitore: string) {
        store.dispatch(StoreActions.UnwatchLavorazioniFornitore, idFornitore);
    }

    get lavorazioni(): LavorazioneSlim[] {
        return store.state.listaLavorazioni;
    }
}

